import constants from 'constants/index'

const categoryName = (categoryId) => {
  return constants.complaint.COMPLAINT_CATEGORIES.find(
    (category) => category.id === categoryId,
  )?.name
}

export default categoryName
